export default "__VITE_ASSET__B7l1X3L3__"